import LazyLoadComponent from 'app/developer-v3/components/LazyLoadComponent';
const LazyLoadUsageGraph = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'app-developer-v3-pages-dashboard-Dashboard-UsageGraph-UsageGraph' */ 'app/developer-v3/pages/dashboard/Dashboard/UsageGraph/UsageGraph'
    ),
});
export default LazyLoadUsageGraph;
